import { useMemo } from 'react'

import ArrayOfStringsWithPrimary from '../ArrayOfStringsWithPrimary'
import useSelectCustomFieldValueForKeyAndType from '../useSelectCustomFieldValueForKeyAndType'

const MAX_EMAIL_ADDRESSES = 6

export default function ContactHeaderFieldsEmails({ doRecalcMenuPosition }) {
  const email = useSelectCustomFieldValueForKeyAndType(
    'contact_email',
    'CONTACT'
  )
  const email1 = useSelectCustomFieldValueForKeyAndType(
    'contact_secondary_email1',
    'CONTACT'
  )
  const email2 = useSelectCustomFieldValueForKeyAndType(
    'contact_secondary_email2',
    'CONTACT'
  )
  const email3 = useSelectCustomFieldValueForKeyAndType(
    'contact_secondary_email3',
    'CONTACT'
  )
  const email4 = useSelectCustomFieldValueForKeyAndType(
    'contact_secondary_email4',
    'CONTACT'
  )
  const email5 = useSelectCustomFieldValueForKeyAndType(
    'contact_secondary_email5',
    'CONTACT'
  )
  const emails = [email, email1, email2, email3, email4, email5]
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const records = useMemo(() => emails, emails)
  return (
    <ArrayOfStringsWithPrimary
      maxRecords={MAX_EMAIL_ADDRESSES}
      noun={'email'}
      onCountChange={doRecalcMenuPosition}
      primaryName="contact_email"
      records={records}
      secondaryNamePrefix="contact_secondary_email"
      title="Emails"
    />
  )
}
